import { ImportChip } from './ChipsSelection.constants';

export const UPLOAD_URL = `/ads/roi-hub/import?section=${ImportChip.FILE_UPLOAD}`;
export const SETUP_EMAIL_INGESTOR_URL = '/ads/roi-hub/setup-email-importer';
